import { request } from '@/shared/api/request'

export const sendByBin = (params) => {
	return request({ url: 'contract/oopv/sendByBin', method: 'POST', params })
}
